// Styles for TabContainer go here.
import { mediaQuery } from '../../utils/styles';
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledTabContainer = styled.div`
  .outdoors-layout {
    .tabpage-edge {
      margin-top: 0px;
    }
    .m-standard-tab-list {
      .m-standard-tab-list-item {
        @media ${mediaQuery.desktop} {
          width: auto !important;
        }
        button {
          padding-right: ${toRem(19)};
          padding-left: ${toRem(19)};
        }
      }
    }
    .center-align {
      .carouselControlType1 {
        @media ${mediaQuery.mobile} {
          height: auto !important;
        }
        @media ${mediaQuery.allTablets} {
          height: auto !important;
        }
      }
    }
    .tabpage-container .container > span > div:nth-of-type(2) .accordion__container .t-horizontal-vertical-rule {
      @media ${mediaQuery.allTablets} {
        display: none;
      }

      @media ${mediaQuery.mobile} {
        display: none;
      }

    }
  }
`;
